module.exports = __webpack_public_path__ + "static/media/jian.12a750dc.jpg";